export default function ({ app, env, redirect }) {
  const router = app.router;
  const BASE_URL = env.MAIN_ESYOIL || process.env.MAIN_ESYOIL || "";

  // Set of route names
  const routeNameSet = new Set();

  // Check if internal route exists, otherwise navigate externally (to refactor)
  const routes = router.options.routes || [];
  routes.forEach((route) => {
    if (route.name) {
      routeNameSet.add(route.name);
    }
    if (route.children?.length) {
      route.children.forEach((child) => {
        if (child.name) {
          routeNameSet.add(child.name);
        }
      });
    }
  });

  router.beforeEach((to, _, next) => {
    if (routeNameSet.has(to.name)) {
      next();
    } else {
      redirect(`${BASE_URL}${to.fullPath}`);
    }
  });
}
